import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from '../logger.service';

@Injectable()
export class CanActivateReportingModuleGuard {
  constructor(private router: Router) {}

  canActivate() {
    if (environment.Apps.ReportingApp) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }

  canActivateChild() {
    if (environment.Apps.ReportingApp) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }
}
